import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { IdTextPair } from '../../models/id-text-pair';
import { MerchantBillingReportsService } from '../../services/merchant-billing-reports.service';
import { ParticipantMerchantBillingService } from '../../services/participant-merchant-billing.service';
import { MerchantBillingReports } from '../../models/merchant-billing-models/merchant-billing-reports';
import { MerchantBillingViewModel } from '../../models/merchant-billing-models/merchant-billing-view-model';
import { TerminalStatusDashboard } from '../../models/merchant-billing-models/terminal-status-dashboard';
import { BillingDate } from '../../models/merchant-billing-models/billing-date';
import Swal from 'sweetalert2';
import { ParticipantViewModel } from '../../models/participant-view-model';
import 'chartjs-plugin-datalabels';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MerchantViewBillingComponent } from '../merchant-view-billing/merchant-view-billing.component';

@Component({
  selector: 'merchant-graphs-component',
  templateUrl: './merchant-graphs.component.html',
  styleUrls: ['./merchant-graphs.component.scss']
})
export class MerchantGraphsComponent implements OnInit {
  private subscription: Subscription;
  public isUsersLastInteraction: boolean
  public currentDashboard: string = 'chatgraphs';
  public terminalStatusDashboard: TerminalStatusDashboard;
  public merchantBillingData: MerchantBillingViewModel;
  public merchantBillingTopSelected: MerchantBillingReports[];
  public merchantBillingTopTransaction: MerchantBillingReports[];
  public merchantBillingNames: IdTextPair[] = [];
  public merchantBillingDates: IdTextPair[] = [];
  public highestMerchantBillingReport: MerchantBillingReports[] = [];
  public selectedType: string;
  merchantbillingValue: string;
  dateValue: string;

  @Input() getBillingDate: BillingDate;
  @Input() merchantBillingId: string;
  @Output() valueChanged = new EventEmitter<{ merchantBillingNames: any[], merchantBillingDates: any[] }>();
  @Output() hasBillingReport: EventEmitter<boolean> = new EventEmitter<boolean>();

  dataIso: any[] = [];
  dataSetIso = [];
  labelsIso: string[] = [];
  optionsIso = {};
  chartTypeIso = 'doughnut';
  legendIso = true;
  colorsIso = [{
    backgroundColor: []
  },];

  dataTrand: any[] = [];
  dataSetTrand = [];
  labelsTrand = [];
  optionsTrand = {};
  chartTypeTrand = 'doughnut';
  legendTrand = true;
  colorsTrand = [{
    backgroundColor: ['#2e73a8', '#f5a623'],
  },];

  chartTypeActivation = 'bar';
  dataSetActivation = [];
  labelsActivation = [];
  optionsActivation = {};
  legendActivation = true;
  colorsActivation = [{ backgroundColor: ['#2e73a8', '#f5a623'] }];

  dataTrasaction: any[] = [];
  dataSetTransaction = [];
  labelsTrasaction = [];
  optionsTrasaction = {};
  chartTypeTrasaction = 'bar';
  legendTrasaction = true;
  colorsTrasaction = [];
  trasactionLabel: string = "Top 10 Transaction";
  bgTransAmountColor: string = '#C9DFEC';
  bgTransCountColor: string = '';
  constructor(
    private _modalService: NgbModal,
    private _userDataStore: UserDataStoreService,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _merchantBillingReportsService: MerchantBillingReportsService,
    private _participantMerchantBillingService: ParticipantMerchantBillingService,
  ) {
    this.subscription = this._userDataStore.selectedParticipantObservable.subscribe(async () => {
    });
  }

  ngOnInit() {
    this.loadMerchantBillingNames();
    this.loadMerchantBillingReports(this.getBillingDate.id, this.getBillingDate.dates);
    this.selectedType = 'sales';
  }

  public async loadMerchantBillingNames(): Promise<void> {
    var selectedParticipant = new BehaviorSubject<ParticipantViewModel>(JSON.parse(localStorage.getItem('selectedParticipant')));
    var selectedParticipantId = selectedParticipant.value.id.toString();
    this.merchantBillingNames = (await this._participantMerchantBillingService.GetById(Number(selectedParticipantId))).map((x) => {
      return { id: x.id.toString(), text: x.name }
    });
    if (this.merchantBillingNames.length > 1) {
      this.merchantBillingNames.sort((a, b) => {
        if (a.id === selectedParticipantId) return -1;
        if (b.id === selectedParticipantId) return 1;
        return 0;
      });
    }
  }

  async receiveData(selectedValue: number, selectedDateValue: string): Promise<void> {
    this.loadMerchantBillingReports(selectedValue, selectedDateValue);
  }

  public async loadMerchantBillingReports(merchantId: number = 0, date: string = ''): Promise<void> {
    this._ngxUiLoaderService.start();
    const _merchantBillingReports: MerchantBillingViewModel = await this._merchantBillingReportsService.GetById(merchantId, date);
    if (_merchantBillingReports.merchantBillingReports.length < 1) {
      Swal.fire({
        title: "No Merchant Billing Reports",
        text: "Merchant Billing Reports not found",
        icon: "error"
      });
      this._ngxUiLoaderService.stop();
      return;
    }
    else {
      this.hasBillingReport.emit(true);
      this.merchantBillingData = _merchantBillingReports;

      this.processBillingDates(_merchantBillingReports.billingDates);
      this.processIsoGraphs(_merchantBillingReports.deviceGraphs);
      this.processTrendData(_merchantBillingReports.terminalTradedStatusDashboard);
      this.setTerminalStatusDashboard(_merchantBillingReports.terminalStatusDashboard);
      this.processTransactionData(_merchantBillingReports.merchantBillingTopSelected);

      this.valueChanged.emit({ merchantBillingNames: this.merchantBillingNames, merchantBillingDates: this.merchantBillingDates });
    }
    this._ngxUiLoaderService.stop();
  }

  public async onMerchantbillingChange(deviceId: string): Promise<void> {
    this.dataSetTransaction = [
      {
        label: 'Top 10 Transactions',
        data: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        backgroundColor: 'rgba(0, 123, 255, 0.7)',
        borderColor: 'rgba(0, 123, 255, 1)',
        borderWidth: 1,
      },
    ];
  }

  public async onMerchantbillingChangeByDate(deviceId: string): Promise<void> {
    this.dataSetTransaction = [
      {
        label: 'Top 10 Transactions',
        data: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        backgroundColor: 'rgba(0, 123, 255, 0.7)',
        borderColor: 'rgba(0, 123, 255, 1)',
        borderWidth: 1,
      },
    ];
  }

  onChangeBillType(event: any) {
    this._ngxUiLoaderService.start();
    this.dataTrasaction = [];
    this.labelsTrasaction = [];
    this.dataSetTransaction = [];
    this.highestMerchantBillingReport == [] as MerchantBillingReports[];

    if (this.selectedType === "trans") {
      this.highestMerchantBillingReport = this.merchantBillingData.merchantBillingTopTransaction;
      this.trasactionLabel = "Top 10 Transaction Count";
      for (let i = 0; i < this.highestMerchantBillingReport.length; i++) {
        this.labelsTrasaction.push(this.highestMerchantBillingReport[i].merchantName);
        this.dataTrasaction.push(parseFloat(String(this.highestMerchantBillingReport[i].transaction).replace(',', '.')));
      }
      this.bgTransAmountColor = '';
      this.bgTransCountColor = '#C9DFEC';
    }
    else {
      this.highestMerchantBillingReport = this.merchantBillingData.merchantBillingTopSelected;
      this.trasactionLabel = "Top 10 Transaction Amount";
      for (let i = 0; i < this.highestMerchantBillingReport.length; i++) {
        this.labelsTrasaction.push(this.highestMerchantBillingReport[i].merchantName);
        this.dataTrasaction.push(parseFloat(String(this.highestMerchantBillingReport[i].value).replace(',', '.')));
      }
      this.bgTransAmountColor = '#C9DFEC';
      this.bgTransCountColor = '';
    }

    this.processTransaction(this.labelsTrasaction, this.dataTrasaction);

    this._ngxUiLoaderService.stop();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private processBillingDates(dates: BillingDate[]): void {
    this.merchantBillingDates = dates.map(x => ({
      id: x.id.toString(),
      text: x.dates.toString()
    }));
  }

  private processIsoGraphs(deviceModelGraphs: any[]): void {
    var _deviceColors = [];
    this.dataIso = [];
    this.labelsIso = [];
    this.optionsIso = {
      responsive: true,
      plugins: {
        legend: { display: false },
        tooltip: { enabled: true },
        datalabels: {
          color: '#ffffff'
        }
      },
      cutout: '70%',
    };
    for (let i = 0; i < deviceModelGraphs.length; i++) {
      this.dataIso.push(deviceModelGraphs[i].quantity);
      this.labelsIso.push(deviceModelGraphs[i].deviceModel);
      _deviceColors.push(deviceModelGraphs[i].color);
    }
    this.colorsIso = [{
      backgroundColor: _deviceColors,
    },];
  }

  private processTrendData(status: any): void {

    this.optionsTrand = {
      responsive: true,
      plugins: {
        legend: { display: false },
        tooltip: { enabled: true },
        datalabels: {
          color: '#ffffff'
        }
      },
      cutout: '70%',
    };
    this.dataTrand = [status.tradedNumber, status.unTradedNumber];
    this.labelsTrand = [
      [status.tradedDescription, status.tradedNumber],
      [status.unTradedDescription, status.unTradedNumber]
    ];

    this.dataSetTrand = [{
      label: this.labelsTrand,
      backgroundColor: ['rgba(0, 123, 255, 0.7)', 'rgba(0, 123, 255, 0.7)'],
      borderColor: 'rgba(0, 123, 255, 1)',
      borderWidth: 1
    }];
  }

  private processTransaction(labelsTrasaction: any[], dataTrasaction: any[]): void {

    this.optionsTrasaction = {
      responsive: true,
      plugins: {
        datalabels: {
          display: false
        }
      },
      scales: {
        x: { beginAtZero: true, },
        y: { beginAtZero: true, },
      },
    };

    this.labelsTrasaction = labelsTrasaction;
    this.dataTrasaction = dataTrasaction;

    let labeltrans: string[] = Array(10).fill("");
    const formattedDiscription: string[] = this.labelsTrasaction.map(item => {
      const words = item.trim().split(" ");
      words.pop();
      return words.join(" ");
    });
    for (let i = 0; i < formattedDiscription.length; i++) {
      labeltrans[i] = formattedDiscription[i];
    }
    this.labelsTrasaction = labeltrans;

    let trans: number[] = Array(10).fill(0);
    for (let i = 0; i < this.dataTrasaction.length; i++) {
      trans[i] = this.dataTrasaction[i];
    }

    var transbarcolor = '#2F6FB0';
    this.dataSetTransaction = [
      { data: [trans[0], 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'trans1', backgroundColor: transbarcolor },
      { data: [0, trans[1], 0, 0, 0, 0, 0, 0, 0, 0], label: 'trans2', backgroundColor: transbarcolor },
      { data: [0, 0, trans[2], 0, 0, 0, 0, 0, 0, 0], label: 'trans3', backgroundColor: transbarcolor },
      { data: [0, 0, 0, trans[3], 0, 0, 0, 0, 0, 0], label: 'trans4', backgroundColor: transbarcolor },
      { data: [0, 0, 0, 0, trans[4], 0, 0, 0, 0, 0], label: 'trans5', backgroundColor: transbarcolor },
      { data: [0, 0, 0, 0, 0, trans[5], 0, 0, 0, 0], label: 'trans6', backgroundColor: transbarcolor },
      { data: [0, 0, 0, 0, 0, 0, trans[6], 0, 0, 0], label: 'trans7', backgroundColor: transbarcolor },
      { data: [0, 0, 0, 0, 0, 0, 0, trans[7], 0, 0], label: 'trans8', backgroundColor: transbarcolor },
      { data: [0, 0, 0, 0, 0, 0, 0, 0, trans[8], 0], label: 'trans9', backgroundColor: transbarcolor },
      { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, trans[9]], label: 'trans10', backgroundColor: transbarcolor },
    ];

    this.optionsTrasaction = {
      responsive: true,
      plugins: {
        datalabels: {
          display: true,
          color: '##000000.',
          font: {
            size: 12
          },
          anchor: 'end',
          align: 'start',
          formatter: (value: number) => {
            return value > 0 ? value : '';
          }
        }
      },
      scales: {
        xAxes: [
          {
            stacked: true,
            barPercentage: 0.8,
            categoryPercentage: 0.8,
          }
        ],
        yAxes: [
          {
            stacked: true,
            ticks: {
              beginAtZero: true
            }
          }
        ]
      },
      legend: {
        display: false,
        position: 'top'
      }
    };
  }

  private processTransactionData(data: MerchantBillingReports[]): void {

    this.highestMerchantBillingReport = data;
    this.merchantBillingTopSelected = data;

    this.optionsTrasaction = {
      responsive: true,
      plugins: {
        datalabels: {
          display: false
        }
      },
      scales: {
        x: { beginAtZero: true, },
        y: { beginAtZero: true, },
      },
    };

    this.labelsTrasaction = data.map(d => d.merchantName);
    this.dataTrasaction = data.map(d => parseFloat(String(d.value).replace(',', '.')));

    this.processTransaction(this.labelsTrasaction, this.dataTrasaction);

  }

  setTerminalStatusDashboard(terminalStatusDashboard: TerminalStatusDashboard): void {

    this.terminalStatusDashboard = terminalStatusDashboard;
    var activatedNumber: number = parseFloat(String(this.terminalStatusDashboard.activatedNumber));
    var deActivatedNumber: number = parseFloat(String(this.terminalStatusDashboard.deActivatedNumber));

    this.labelsActivation = [['Active', activatedNumber],
    ['Deactivated', deActivatedNumber]];

    this.dataSetActivation = [
      { data: [activatedNumber, 0], label: 'Active', backgroundColor: '#2F6FB0' },
      { data: [0, deActivatedNumber], label: 'Deactivated', backgroundColor: '#F5A623' }
    ];

    this.optionsActivation = {
      responsive: true,
      plugins: {
        datalabels: {
          display: true,
          color: '#ffffff',
          font: {
            size: 12
          },
          anchor: 'end',
          align: 'start',
          formatter: (value: number) => {
            return value > 0 ? value : '';
          }
        }
      },
      scales: {
        xAxes: [
          {
            stacked: true,
            barPercentage: 0.6,
            categoryPercentage: 0.6,
          }
        ],
        yAxes: [
          {
            stacked: true,
            ticks: {
              beginAtZero: true
            }
          }
        ]
      },
      legend: {
        position: 'top'
      }
    };
  }

  onTableClick(event: any) {
    const tradedItems: MerchantBillingReports[] = this.merchantBillingTopSelected;
    this.viewSelectedDataTable(tradedItems);
  }

  viewSelectedDataTable(selectedMerchantBillingReports: MerchantBillingReports[]): void {
    const dialogRef = this._modalService.open(MerchantViewBillingComponent, {
      windowClass: 'modal-fade-in custom-modal-dialog custom-merchant-modal',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });

    const sortedReports = selectedMerchantBillingReports.sort((a, b) => {
      return parseFloat(b.value) - parseFloat(a.value);
    });

    dialogRef.componentInstance.showCancel = false;
    dialogRef.componentInstance.acceptButtonText = "Close";
    dialogRef.componentInstance.title = sortedReports.length > 0 ? `${sortedReports[0].client} report` : "Merchant billing report";
    dialogRef.componentInstance.merchantBillReports = sortedReports;
  }
}
